if (!customElements.get('line-item')) {
  customElements.define(
    'line-item',
    class LineItem extends HTMLElement {
      connectedCallback() {
        this.setNodeSelectors();
        this.setEventListeners();
      }

      /**
       * Sets the node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          quantity: this.querySelector('[js-line-item="quantity"]'),
          remove: this.querySelector('[js-line-item="remove"]'),
        };
      }

      /**
       * Sets the event listeners.
       */
      setEventListeners() {
        if (this.nodeSelectors.quantity) {
          this.nodeSelectors.quantity.addEventListener('change', (event) => {
            this.updateItem({
              quantity: Number(event.target.value),
            });
          });
        }

        if (this.nodeSelectors.remove) {
          this.nodeSelectors.remove.addEventListener('click', (event) => {
            event.preventDefault();

            this.updateItem({
              quantity: 0,
            });
          });
        }
      }

      /**
       * Updates the line item in the cart.
       * @param {Object} updates - The update data.
       * @param {Number} updates.quantity - The line item quantity.
       */
      async updateItem({ quantity }) {
        const addOnItems = [];

        if (typeof quantity === 'undefined') {
          return;
        }

        if (this.hasAttribute('data-custom-key')) {
          const cart = await fetch(`${theme.routes.cart_url}.js`).then((response) => response.json());

          cart.items.forEach((item) => {
            if (item.properties._add_on_parent && item.properties._add_on_parent === this.dataset.customKey) {
              addOnItems.push(item);
            }
          });
        }

        /**
         * Prevents the event.
         * @param {MouseEvent} event - The event payload.
         */
        function prevent(event) {
          event.preventDefault();
        }

        this.classList.add('is-loading');

        /**
         * Stops the customer from triggering any actions whilst loading.
         */
        this.addEventListener('mousedown', prevent);

        await fetch(theme.routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: {
              [this.dataset.key]: quantity,

              /**
               * Syncs the add on items' quantity with the parent.
               */
              ...addOnItems.reduce((updates, current) => {
                updates[current.key] = Number(this.nodeSelectors.quantity.value);
                return updates;
              }, {}),
            },
          }),
        }).catch(() => {
          this.classList.remove('is-loading');
        });

        if (this.hasAttribute('data-remove-loading')) {
          this.classList.remove('is-loading');

          /**
           * Allows mouse events after loading.
           */
          this.removeEventListener('mousedown', prevent);
        }

        theme.eventBus.emit('cart:update');
      }
    }
  );
}
